module.exports = __webpack_public_path__ + "static/media/rapid1.44898ce5.png";